import { stripUrlQueryKey } from './urlSanitizer';

export interface WorkflowUrlExportSource {
  url_index: number;
  url: string | null;
  api_key?: string | null;
  description: string | null;
  prompt_id: number | null;
  dify_workflow_url: string | null;
  extra_params: unknown;
}

export interface WorkflowPromptTitle {
  id: number | string;
  title: string;
}

export interface WorkflowUrlExport {
  url_index: number;
  url: string | null;
  description: string | null;
  prompt_id: number | null;
  prompt_title: string | null;
  dify_workflow_url: string | null;
  extra_params: unknown;
}

/** Builds the portable client export shape without exposing URL API keys. */
export function buildExportUrls(
  urls: readonly WorkflowUrlExportSource[],
  prompts: readonly WorkflowPromptTitle[],
): WorkflowUrlExport[] {
  const promptTitles = new Map<number, string>();
  for (const prompt of prompts) {
    const promptId = typeof prompt.id === 'number' ? prompt.id : Number(prompt.id);
    if (Number.isInteger(promptId)) {
      promptTitles.set(promptId, prompt.title);
    }
  }

  return urls.map((url) => ({
    url_index: url.url_index,
    url: url.url ? stripUrlQueryKey(url.url) : url.url,
    description: url.description,
    prompt_id: url.prompt_id,
    prompt_title: url.prompt_id === null ? null : (promptTitles.get(url.prompt_id) ?? null),
    dify_workflow_url: url.dify_workflow_url
      ? stripUrlQueryKey(url.dify_workflow_url)
      : url.dify_workflow_url,
    extra_params: url.extra_params,
  }));
}
